export default __webpack_public_path__ + "static/SuisseWorks-Regular-WebS-6b472f499ce2dd49ed610c24249ff1f7.woff2";